import { clientLogin } from '../Clients/query'
export default {
  async Boot ({ commit, dispatch }, url) {
    //Parse subdominio
    let subdominio = url.substr(url.indexOf('//') + 2, url.indexOf('.') - (url.indexOf('//') + 2))
    let empty = await this.$http.post('', {
      query: `query($sub: String) {
        Company(subdominio: $sub) {
          _id
        }
      }`,
      variables: {
        sub: subdominio
      }
    }).then(res => res.data.data.Company._id)
    if(empty === null) {
      commit('CHANGE_THEME', 'Modelo 01')
      commit('CHANGE_EMPRESA', { maps: '' })
      return true
    }
    
    let user = await dispatch('GetPersistLogin')
    if(user.usuario.id !== null) {
      this.$http.defaults.headers.common.id = user.usuario._id
      this.$http.defaults.headers.common._id = user.usuario._id
      this.$http.defaults.headers.common.token = user.usuario.token
      commit('GET_LOGIN', user.usuario)
    }
    
    // if(localStorage.getItem('user') !== null) {
    //   let user = JSON.parse(localStorage.getItem('user'))
    //   this.$http.defaults.headers.common.id = user._id
    //   this.$http.defaults.headers.common._id = user._id
    //   this.$http.defaults.headers.common.token = user.token
    //   commit('GET_LOGIN', user)
    // }

    if(user.usuario.id !== null) {
      if(user.usuario.tipo === 'c') {
        commit('SET_CLIENTEDIT', user)
      }
    }

    // if(localStorage.getItem('client') !== null) {
    //   let client = JSON.parse(localStorage.getItem('client'))
    //   commit('SET_CLIENTEDIT', client)
    // }

    //Guardar as informações da empresa (logo)
    await this.$http.post('', {
      query: `query($sub: String) {
        Company(subdominio: $sub) {
          _id,
          nome_empresa,
          logo,
          modelo,
          publickey,
          whatsapp,
          mp,
          wa,
          maps,
          instagram,
          facebook,
          cep,
          frenteloja,
          metatitle,
          metadescription,
          tagmanagerhead,
          tagmanagerbody
        }
      }`,
      variables: {
        sub: subdominio
      }
    })
    .then(res => {
      commit('SET_EMPRESA', res.data.data.Company)
      this.$http.defaults.headers.common.id = res.data.data.Company._id
      this.$http.defaults.headers.common._id = res.data.data.Company._id
      //carregar o modelo
      commit('CHANGE_THEME', res.data.data.Company.modelo)
      return res.data.data.Company
    })
    .then(async () => {
      await this.$http.post('', {
        query: `query {
          GetPreference {
            id,
            _id,
            comp,
            prop,
            valor
          }
        }`
      })
      .then(res => {
        commit('LOAD_PREFES', res.data.data.GetPreference)
      })
    })
    return true
  },
  PushMsg: ({ commit }, payload) => new Promise((resolve) => {
    commit('PUSH_MSG', payload)
    resolve()
  }),
  DelMsg: ({ commit }, payload) => new Promise((resolve) => {
    commit('DEL_MSG', payload)
    resolve()
  }),
  GetLogin ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `query ($payload: iuserOremail) {
          Login(payload: $payload) {
            message,
            user {
              id,
              _id,
              nome,
              sobrenome,
              usuario,
              email,
              tipo,
              token,
              logincount
            },
            code
          }
        }`,
        variables: {
          payload: payload
        }
      }).then(res => {
        if(res.data.data.Login.user !== null) {
          commit('GET_LOGIN', res.data.data.Login.user)
          this.$http.defaults.headers.common.token = res.data.data.Login.user.token
          if(res.data.data.Login.user.tipo === 'c') {
            this.$http.post('', {
              query: clientLogin,
              variables: {
                payload: {
                  id: res.data.data.Login.user.id,
                  login: payload.login,
                  senha: payload.senha
                }
              }
            })
            .then(res => {
              dispatch('SetClientEdit', res.data.data.GetClientLogin)
                .then(() => {
                  if(this.getters.cupom.codigo !== '') {
                    dispatch('GetGiftStore', { 
                      codigo: this.getters.cupom.codigo,
                      usuario: this.getters.SelectedClientEdit.usuario,
                      itens: this.getters.CheckoutItens01,
                      pedidoid: 0
                    })
                  }
                })
            })
          }
        }
        resolve(res.data.data.Login)
      })
    })
  },
  GetPersistLogin () { 
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
        query {
          GetPersistLogin {
            usuario {
              id,
              _id,
              nome,
              sobrenome,
              usuario,
              email,
              permissao,
              permissao,
              tipo,
              status,
              logincount,
              token
            },
            endereco {
              id,
              _id,
              cpf,
              celular,
              cep,
              endereco,
              bairro,
              numero,
              cidade,
              uf
            }
          }
        }
        `
      })
      .then(res => {
        resolve(res.data.data.GetPersistLogin)
      })
    })
  },
  GetLogout ({ commit }) { 
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query {
            SessionDestroy
          }
        `
      })
      commit('GET_LOGOUT')
      resolve()
    })
  },
  PushMultiSelect: ({ commit }, payload) => new Promise((resolve) => {
    commit('PUSH_MULTI_SELECT', payload)
    resolve()
  }),
  DelMultiSelect: ({ commit }, payload) => new Promise((resolve) => {
    commit('DEL_MULTI_SELECT', payload)
    resolve()
  }),
  SetMultiSelect: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_MULTI_SELECT', payload)
    resolve()
  }),
  ChangeUserEdit: ({ commit }, payload) => new Promise((resolve) => {
    commit('CHANGE_USER_EDIT', payload)
    resolve()
  }),
  ChangeUserPermission: ({ commit }, payload) => new Promise((resolve) => {
    commit('CHANGE_USER_PERMISSION', payload)
    resolve()
  }),
  PushUser ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      let newUser = {
        usuario: payload.usuario,
        nome: payload.nome,
        sobrenome: payload.sobrenome,
        email: payload.email,
        senha: payload.senha,
        permissao: JSON.stringify(payload.permissao)
      }
      this.$http.post('', {
        query: `
          mutation ($payload: iuser) {
            _CreateUser (payload: $payload) {
              id,
              usuario,
              nome,
              sobrenome,
              email,
              permissao,
              tipo,
              status
            }
          }
        `,
        variables: {
          payload: newUser
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: 'Usuário cadastrado com sucesso', color: 'green' })
        commit('PUSH_USER', res.data.data._CreateUser)
        commit('CLEAR_USER_EDIT')
        resolve()
      })
    })
  },
  UpdateUser ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      payload.payload.status = payload.status
      payload.payload.permissao = JSON.stringify(payload.payload.permissao)
      this.$http.post('', {
        query: `
          mutation ($payload: iuser) {
            _UpdateUser (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload.payload
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: res.data.data._UpdateUser.message, color: !res.data.data._UpdateUser.status ? 'red' : 'green' })
        payload.payload.permissao = JSON.parse(payload.payload.permissao)
        commit('UPDATE_USER', payload)
        resolve()        
      })
    })
  },
  DeleteUser ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      dispatch('Loading', true)
      this.$http.post('', {
        query: `
          mutation ($payload: Int) {
            _DeleteUser (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload.id
        }
      })
      .then(res => {
        dispatch('Loading', false)
        dispatch('PushMsg', { msg: res.data.data._DeleteUser.message, color: 'green' })
        commit('DELETE_USER', payload)
        resolve()        
      })
    })
  },
  SetUserEdit: ({ commit }, payload) => new Promise((resolve) => {
    commit('SET_USER_EDIT', payload)
    resolve()
  }),
  ChangeTheme: ({ commit }, payload) => new Promise((resolve) => {
    commit('CHANGE_THEME', payload)
    resolve()
  }),
  ToggleSearchLoad: ({ commit }, payload) => new Promise((resolve) => {
    commit('TOGGLE_SEARCH_LOAD', payload)
    resolve()
  }),
  UpdateLogo ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `mutation($payload: ilogo) {
          _UpdateLogo(payload: $payload) {
            status,
            message
          }
        }`,
        variables: {
          payload: {
            img: payload
          }
        }
      })
      .then(res => {
        console.log(res)
        if(!res.data.data._UpdateLogo.status) {
          dispatch('PushMsg', { msg: res.data.data._UpdateLogo.message, color: 'red' })
        }
        commit('UPDATE_LOGO', payload)
        resolve()
      })
    })
  },
  UpdateFontDefault: ({ commit }, payload) => new Promise((resolve) => {
    commit('UPDATE_FONT_DEFAULT', payload)
    resolve()
  }),
  UpdatePrefComp: ({ commit }, payload) => new Promise((resolve) => {
    commit('UPDATE_PREF_COMP', payload)
    resolve()
    // dispatch('VerifyPermission', [26])
    //   .then(res => {
    //     if(res) {
    //       commit('UPDATE_PREF_COMP', payload)
    //       resolve()
    //     }
    //     else {
    //       dispatch('PushMsg', { msg: 'Sem permissão', color: 'red' })
    //       resolve()
    //     }
    //   })
  }),
  VerifyPermission: ({ getters }, payload) => new Promise((resolve) => {
    let permissions = []
    for(let key in payload) {
      if(getters.Profile.permission.filter(p => p.active).map(p => p.id).indexOf(payload[key]) !== -1) {
        permissions.push(payload[key])
      }
    }
    if(permissions.length === payload.length) {
      resolve(true)
    } else {
      resolve(false)
    }
  }),
  createCompany (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `mutation ($icompany: icompany) {
          _Company(icompany: $icompany) {
            status,
            message
          }
        }`,
        variables: {
          icompany: payload
        }
      })
      .then(res => {
        resolve(res.data.data._Company)
      })
    })
  },
  GetUser ({ commit, dispatch }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: ` query ($payload: ilastlimit) {
          GetUser (payload: $payload) {
            status,
            message,
            users {
              id,
              _id,
              nome,
              sobrenome,
              permissao,
              usuario,
              email,
              tipo,
              status
            }
          } 
        }`,
        variables: {
          payload: payload.params
        }
      })
      .then(res => {
        if(!res.data.data.GetUser.status) {
          dispatch('PushMsg', { msg: res.data.data.GetUser.message, color: 'red' })
          commit('GET_USER', { payload: [], init: payload.init })
          resolve()
        }
        else {
          res.data.data.GetUser.users.map(u => {
            u.permissao = JSON.parse(u.permissao)
          })
          commit('GET_USER', { payload: res.data.data.GetUser.users, init: payload.init })
          resolve()
        }
      })
    })
  },
  _UpdateUser ({ dispatch }, payload) {
    return new Promise((resolve) => {
      payload.permissao = JSON.stringify(payload.permissao)
      this.$http.post('', {
        query: `mutation ($payload: iuser) {
          _UpdateUser(payload: $payload) {
            status,
            message
          }
        }`,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        payload.permissao = JSON.parse(payload.permissao)
        dispatch('PushMsg', { msg: res.data.data._UpdateUser.message, color: res.data.data._UpdateUser.status ? 'green' : 'red' })
        resolve()
      })
    })
  },
  ParsePrefes ({ getters }) {
    let Prefes = getters.Prefes
    let parsePrefes = []
    for(let key in Prefes) {
      for(let k in Prefes[key]) {
        parsePrefes.push({
          _id: getters.Empresa._id,
          comp: key,
          prop: k,
          valor: Prefes[key][k]
        })
      }
    }
    return parsePrefes
  },
  async _UpdatePreference ({ dispatch }) {
    return this.$http.post('', {
      query: `mutation($payload: [ipreference]) {
        _UpdatePreference(payload: $payload) {
          status,
          message
        }
      }`,
      variables: {
        payload: await dispatch('ParsePrefes')
      }
    })
    .then(res => {
      dispatch('PushMsg', { msg: res.data.data._UpdatePreference.message, color: res.data.data._UpdatePreference.status ? 'green' : 'red' })
    })
  },
  Loading ({ commit }, payload) {
    commit('LOADING', payload)
  },
  Payment (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: payment) {
            _Payment (payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(JSON.parse(res.data.data._Payment))
      })
    })
  },
  setUserValidate ({ commit }, payload) {
    commit('SET_USERVALIDATE', payload)
  },
  sendMessageWhats (_, payload) {
    return new Promise((resolve) => {
      let msg = `Oi tudo bom%3F+ Gostaria de saber mais sobre o imóvel ${payload.name} a ${payload.oferta > 0 ? payload.oferta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : payload.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}`
      window.location.replace(`https://wa.me/55${this.getters.Empresa.whatsapp}?text=${msg}`)
      resolve()
    })
  },
  VerifySubdominioHas (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: String) {
            VerifySubdominioHas(payload: $payload)
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data.VerifySubdominioHas)
      })
    })
  },
  PersistLogin ({ commit }) {
    return new Promise((resolve) => {
      if(localStorage.getItem('user') !== null) {
        let user = JSON.parse(localStorage.getItem('user'))
        commit('GET_LOGIN', user)
      }
      resolve()
    })
  },
  GetPwRecovery ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: ipwrecoveryemail) {
            GetPwRecovery (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('CHANGE_PWRECOVERY' , payload)
        resolve(res.data.data.GetPwRecovery)
      })
    })
  },
  GetCodeVerify ({ commit }, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          query ($payload: ipwrecoveryemail) {
            GetCodeVerify (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        commit('CHANGE_PWRECOVERY' , payload)
        resolve(res.data.data.GetCodeVerify)
      })
    })
  },
  _UpdatePw (_, payload) {
    return new Promise((resolve) => {
      this.$http.post('', {
        query: `
          mutation ($payload: ipwrecoveryemail) {
            _UpdatePw (payload: $payload) {
              status,
              message
            }
          }
        `,
        variables: {
          payload: payload
        }
      })
      .then(res => {
        resolve(res.data.data._UpdatePw)
      })
    })
  }
}
